// extracted by mini-css-extract-plugin
export default {"more":"index_more_g1BXx"};